import React, { useEffect, useRef, useState } from 'react';
import { useParams } from "react-router-dom";
import { useFormik } from 'formik';
import * as Yup from 'yup';

import api from '../api/api';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import { classNames } from 'primereact/utils';
import { BrCalendar } from './BrCalendar';
import { ErrorValidationMessage } from './ErrorValidationMessage';
import { FormPreparoSolo } from './FormPreparoSolo';
import { FormPraticasConservacionistas } from './FormPraticasConservacionistas';
import { FormSementesEMudas } from './FormSementesEMudas';
import { FormIrrigacao } from './FormIrrigacao';
import { FormAdubacaoCorrecao } from './FormAdubacaoCorrecao';
import { FormAplicacaoProdutosQuimicos } from './FormAplicacaoProdutosQuimicos';
import { TabelaAdubacaoCorrecao } from './TabelaAdubacaoCorrecao';
import { TabelaAplicacaoProdutosQuimicos } from './TabelaAplicacaoProdutosQuimicos';
import { useHistory } from 'react-router-dom';
import { TabView, TabPanel } from 'primereact/tabview';
import { DialogPrintCaderno } from './DialogPrintCaderno';

export const FormCaderno = ({ isEditing, isLoading, }) => {
    const [isSubmiting, setIsSubmiting] = useState(false);
    const [showFormCaderno, setShowFormCaderno] = useState(false);
    const [adubacoesCorrecao, setAdubacoesCorrecao] = useState([]);
    const [aplicacoesProdutosQuimicos, setAplicacoesProdutosQuimicos] = useState([]);
    const [visualCodigo, setVisualCodigo] = useState("");
    const [visualCulturaAtual, setVisualCulturaAtual] = useState("");
    const history = useHistory();
    const [produtosAntigoId, setProdutosAntigoId] = useState([]);
    const [produtosId, setProdutosId] = useState([]);
    const [hasErrorPreparoSolo, setHasErrorPreparoSolo] = useState(false);
    const [hasErrorSementesEMudas, setHasErrorSementesEMudas] = useState(false);
    const [hasErrorIrrigacao, setHasErrorIrrigacao] = useState(false);
    const [isAdubacaoCorrecaoValid, setIsAdubacaoCorrecaoValid] = useState(false);
    const [isAplicacaoProdutosQuimicosValid, setIsAplicacaoProdutosQuimicosValid] = useState(false);

    const [adubacaoValidated, setAdubacaoValidated] = useState(false);
    const [aplicacaoValidated, setAplicacaoValidated] = useState(false);

    const [produtoAntigoPrint] = useState("");
    const [produtoPrint] = useState("");

    const [showPrintCaderno, setShowPrintCaderno] = useState(false);
    const [cadernoPrint, setCadernoPrint] = useState([]);

    const { id } = useParams();
    const toast = useRef(null);
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);

    const tabHeaderStyle = {
        normal: {
            color: '#697581',
            fontWeight: 'bold',
            padding: '0.75rem 7.1rem',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            flex: 1,
            textAlign: 'center',
        },
        error: {
            color: 'red',
            fontWeight: 'bold',
            padding: '0.75rem 7.1rem',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            flex: 1,
            textAlign: 'center',
        },
        hover: {
            borderBottom: '1px solid #697581'
        },
        active: {
            color: '#007ad9',
            borderBottom: '2px solid #007ad9'
        }
    };

    const [activeIndex, setActiveIndex] = useState(0);

    const [visitedTabs, setVisitedTabs] = useState({
        preparoSolo: false,
        sementesEMudas: false,
        irrigacao: false,
        adubacaoCorrecao: false,
        aplicacaoProdutosQuimicos: false,
    });

    const schema = Yup.object().shape({

        produtoAntigoId: Yup
            .number()
            .nullable()
            .required("O produto é obrigatório")
            .positive("O produto deve ser selecionado")
            .integer("O produto deve estar na lista"),
        identificacaoArea: Yup
            .string()
            .required("A identificação da área é obrigatória.")
            .max(200, "A identificação da área deve ter no máximo 200 caracteres."),
        dataPlantio: Yup
            .date()
            .nullable()
            .required("A data de plantio é obrigatória."),
        dataColheita: Yup
            .date()
            .nullable()
            .required("A data de colheita é obrigatória.")
            .min(Yup.ref('dataPlantio'), "A data de colheita não pode ser anterior à data de plantio."),
        preparoSolo: Yup.object().shape({
            subsolagem: Yup.boolean(),
            aracao: Yup.boolean(),
            enxadaRotativa: Yup.boolean(),
            gradagemComGrade: Yup.boolean(),
            leve: Yup.boolean(),
            pesada: Yup.boolean(),
            niveladora: Yup.boolean(),
            outras: Yup.boolean(),
            descricaoOutras: Yup.string()
                .max(200, "A descrição deve ter no máximo 200 caracteres.")
                .when("outras", {
                    is: true,
                    then: Yup.string().required('O campo "Outros" é obrigatório.'),
                }),
        }).test(
            "gradagem-validation",
            "Pelo menos uma opção de gradagem deve ser selecionada.",
            function (value) {
                const { gradagemComGrade, leve, pesada, niveladora } = value;
                if (gradagemComGrade) {
                    return leve || pesada || niveladora;
                }
                return true;
            }
        )
            .test(
                "preparoSolo-validation",
                "Pelo menos uma opção deve ser selecionada.",
                function (value) {
                    const { naoNecessarias, subsolagem, aracao, enxadaRotativa, gradagemComGrade, leve, pesada, niveladora, outras } = value;
                    if (!naoNecessarias) {
                        return subsolagem || aracao || enxadaRotativa || gradagemComGrade || leve || pesada || niveladora || outras;
                    }
                    return true;
                }
            ),
        praticasConservacionistas: Yup.object().shape({
            naoNecessarias: Yup.boolean(),
            plantioEmNivel: Yup.boolean(),
            terracos: Yup.boolean(),
            rotacaoDeCulturas: Yup.boolean(),
            adubacaoVerde: Yup.boolean(),
            outras: Yup.boolean(),
            descricaoOutras: Yup.string()
                .max(200, "A descrição deve ter no máximo 200 caracteres.")
                .when("outras", {
                    is: true,
                    then: Yup.string().required('O campo "Outros" é obrigatório.'),
                }),

        }).test(
            "praticas-validation",
            "Pelo menos uma opção deve ser selecionada.",
            function (value) {
                const { naoNecessarias, plantioEmNivel, terracos, rotacaoDeCulturas, adubacaoVerde, outras } = value;
                if (!naoNecessarias) {
                    return plantioEmNivel || terracos || rotacaoDeCulturas || adubacaoVerde || outras;
                }
                return true;
            }
        ),
        sementesEMudas: Yup.object().shape({
            proprias: Yup.boolean(),
            terceiros: Yup.boolean(),
            viveiroComTermico: Yup.boolean(),
            viveiroSemTermico: Yup.boolean(),
        }).test(
            "sementesEMudas-validation",
            "Pelo menos uma opção deve ser selecionada.",
            function (value) {
                const { naoNecessarias, proprias, terceiros, viveiroComTermico, viveiroSemTermico } = value;
                if (!naoNecessarias) {
                    return proprias || terceiros || viveiroComTermico || viveiroSemTermico;
                }
                return true;
            }
        ),
        irrigacao: Yup.object().shape({
            naoNecessarias: Yup.boolean(),
            sistema: Yup.string()
                .max(200, "A descrição do Sistema de irrigação deve ter no máximo 200 caracteres.")
                .when("naoNecessarias", {
                    is: false,
                    then: Yup.string().required('O campo "Sistema de Irrigação" é obrigatório.'),
                }),
            origem: Yup.string()
                .max(200, "A descrição da Origem da água deve ter no máximo 200 caracteres.")
                .when("naoNecessarias", {
                    is: false,
                    then: Yup.string().required('O campo "Origem da Água" é obrigatório.'),
                }),
        }).test(
            "irrigacao-validation",
            "Pelo menos um campo deve ser preenchido.",
            function (value) {
                const { naoNecessarias, sistema, origem } = value;
                if (!naoNecessarias) {
                    return sistema || origem;
                }
                return true;
            }
        ),
    });

    const formik = useFormik({
        initialValues: {
            id: "",
            boletimItemId: "",
            produtoId: "",
            dataPlantio: "",
            dataColheita: "",
            identificacaoArea: "",
            produtoAntigoId: "",
            preparoSolo: {
                naoNecessarias: false,
                subsolagem: false,
                aracao: false,
                enxadaRotativa: false,
                gradagemComGrade: false,
                leve: false,
                pesada: false,
                niveladora: false,
                outras: false,
                descricaoOutras: "",
            },
            praticasConservacionistas: {
                naoNecessarias: false,
                plantioEmNivel: false,
                terracos: false,
                rotacaoDeCulturas: false,
                adubacaoVerde: false,
                outras: false,
                descricaoOutras: "",
                validacaoPraticas: true,
            },
            sementesEMudas: {
                naoNecessarias: false,
                proprias: false,
                terceiros: false,
                viveiroComTermico: false,
                viveiroSemTermico: false,
            },
            irrigacao: {
                naoNecessarias: false,
                sistema: "",
                origem: "",
            },
            "adubacaoCorrecao": [],
            "aplicacaoProdutosQuimicos": [],
        },
        validationSchema: schema,
        enableReinitialize: true,
        onSubmit: async (data) => {

            setVisitedTabs({
                preparoSolo: true,
                sementesEMudas: true,
                irrigacao: true,
                adubacaoCorrecao: true,
                aplicacaoProdutosQuimicos: true,
            });

            formik.setTouched({
                preparoSolo: true,
                praticasConservacionistas: true,
                sementesEMudas: true,
                irrigacao: true,
                adubacaoCorrecao: true,
                aplicacaoProdutosQuimicos: true,
            });

            setIsSubmiting(true);

            data.adubacaoCorrecao = adubacoesCorrecao;
            data.aplicacaoProdutosQuimicos = aplicacoesProdutosQuimicos;

            try {

                if (!data.adubacaoCorrecao || data.adubacaoCorrecao.length === 0) {
                    formik.setFieldError("adubacaoCorrecao", "Pelo menos um item de Adubação e Correção deve ser adicionado.");
                    throw new Error("Pelo menos um item de Adubação e Correção deve ser adicionado.");
                } else {
                    formik.setFieldError("adubacaoCorrecao", "");
                }

                if (!data.aplicacaoProdutosQuimicos || data.aplicacaoProdutosQuimicos.length === 0) {
                    formik.setFieldError("aplicacaoProdutosQuimicos", "Pelo menos um item de Aplicação de Produtos Químicos deve ser adicionado.");
                    throw new Error("Pelo menos um item de Aplicação de Produtos Químicos deve ser adicionado.");
                } else {
                    formik.setFieldError("aplicacaoProdutosQuimicos", "");
                }

                await schema.validate(data, { abortEarly: false });

                const dadosCompletos = {
                    id: data.id,
                    boletimItemId: data.boletimItemId,
                    produtoAntigoId: data.produtoAntigoId,
                    dataPlantio: data.dataPlantio,
                    dataColheita: data.dataColheita,
                    areaCultivo: data.identificacaoArea,
                    preparoSolo: {
                        naoNecessarias: data.preparoSolo.naoNecessarias,
                        subsolagem: data.preparoSolo.subsolagem,
                        aracao: data.preparoSolo.aracao,
                        enxadaRotativa: data.preparoSolo.enxadaRotativa,
                        gradagemComGrade: data.preparoSolo.gradagemComGrade,
                        leve: data.preparoSolo.leve,
                        pesada: data.preparoSolo.pesada,
                        niveladora: data.preparoSolo.niveladora,
                        outras: data.preparoSolo.outras,
                        descricaoOutras: data.preparoSolo.descricaoOutras,
                    },
                    sementesEMudas: {
                        naoNecessarias: data.sementesEMudas.naoNecessarias,
                        proprias: data.sementesEMudas.proprias,
                        terceiros: data.sementesEMudas.terceiros,
                        viveiroComTermico: data.sementesEMudas.viveiroComTermico,
                        viveiroSemTermico: data.sementesEMudas.viveiroSemTermico,
                    },
                    praticasConservacionistas: {
                        naoNecessarias: data.praticasConservacionistas.naoNecessarias,
                        plantioEmNivel: data.praticasConservacionistas.plantioEmNivel,
                        terracos: data.praticasConservacionistas.terracos,
                        rotacaoDeCulturas: data.praticasConservacionistas.rotacaoDeCulturas,
                        adubacaoVerde: data.praticasConservacionistas.adubacaoVerde,
                        outras: data.praticasConservacionistas.outras,
                        descricaoOutras: data.praticasConservacionistas.descricaoOutras,
                    },
                    irrigacao: {
                        naoNecessarias: data.irrigacao.naoNecessarias,
                        sistema: data.irrigacao.sistema,
                        origem: data.irrigacao.origem,
                    },
                    adubacaoCorrecao: adubacoesCorrecao,
                    aplicacaoProdutosQuimicos: aplicacoesProdutosQuimicos,
                };


                if (!isEditing) {
                    formik.resetForm();
                    const response = await api.post("caderno", dadosCompletos);
                    console.log("Resposta da API (Salvar):", response.data);
                    toast.current.show({ life: 2000, severity: 'success', summary: 'Cadastro cadastrado!', detail: `Caderno adicionado com sucesso` });
                    setTimeout(() => {

                        history.push('/boletim')

                    }, 2000)
                } else {
                    const response = await api.put("caderno", dadosCompletos);
                    console.log("Resposta da API (Editar):", response.data);
                    toast.current.show({ life: 2000, severity: 'success', summary: 'Cadastro atualizado!', detail: `Caderno atualizado com sucesso` });
                    setTimeout(() => {

                        history.push('/boletim')

                    }, 2000)
                }
            }
            catch (error) {
                setVisitedTabs({
                    preparoSolo: true,
                    sementesEMudas: true,
                    irrigacao: true,
                    adubacaoCorrecao: true,
                    aplicacaoProdutosQuimicos: true,
                });
                if (!isEditing)
                    toast.current.show({ life: 2000, severity: 'error', summary: 'Erro ao cadastrar caderno!', detail: error.toString() });
                else
                    toast.current.show({ life: 2000, severity: 'error', summary: 'Erro ao editar caderno!', detail: error.toString() });
                console.error('Erro ao atualizar caderno:', error.response?.data || error.message);
            }
            setIsSubmiting(false);
        }

    });

    const handlePrintClick = () => {

        api.get(`/caderno/${formik.values.id}`).then((response) => {

            const produtoAntigoLabel = produtosAntigoId.find(p => p.value === formik.values.produtoAntigoId)?.label || "";
            const produtoLabel = produtosId.find(p => p.value === formik.values.produtoId)?.label || "";

            const cadernoCompleto = {
                ...response.data,
                id: visualCodigo || formik.values.id,
                produtoAntigoId: produtoAntigoLabel,
                produtoId: produtoLabel,
                identificacaoArea: formik.values.identificacaoArea
            };

            setCadernoPrint([cadernoCompleto]);
        }).catch(error => {
            console.error('Erro ao buscar caderno:', error);
        });
        setShowPrintCaderno(true);
    };

    useEffect(() => {
        const hasError = (
            formik.errors.preparoSolo && Object.keys(formik.errors.preparoSolo).length > 0 &&
            formik.touched.preparoSolo && Object.keys(formik.touched.preparoSolo).length > 0
        );
        console.log("Erro no Preparo do Solo:", hasError);
        setHasErrorPreparoSolo(hasError);
    }, [formik.errors.preparoSolo, formik.touched.preparoSolo]);

    useEffect(() => {
        const hasError = (
            formik.errors.sementesEMudas && Object.keys(formik.errors.sementesEMudas).length > 0 &&
            formik.touched.sementesEMudas && Object.keys(formik.touched.sementesEMudas).length > 0
        );
        console.log("Erro em Sementes e Mudas:", hasError);
        setHasErrorSementesEMudas(hasError);
    }, [formik.errors.sementesEMudas, formik.touched.sementesEMudas]);

    useEffect(() => {
        const hasError = (
            formik.errors.irrigacao && Object.keys(formik.errors.irrigacao).length > 0 &&
            formik.touched.irrigacao && Object.keys(formik.touched.irrigacao).length > 0
        );
        console.log("Erro na Irrigação:", hasError);
        setHasErrorIrrigacao(hasError);
    }, [formik.errors.irrigacao, formik.touched.irrigacao]);

    useEffect(() => {
        formik.setFieldValue("adubacaoCorrecao", adubacoesCorrecao);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [adubacoesCorrecao]);

    useEffect(() => {
        formik.setFieldValue("aplicacaoProdutosQuimicos", aplicacoesProdutosQuimicos);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [aplicacoesProdutosQuimicos]);

    useEffect(() => {
        //carrega a lista de produtos antigos
        async function carregarProdutosAntigoId() {
            try {
                const responseProdutos = await api.get('produto/produtosAll');

                const nomesUnicos = new Set();

                const produtosFiltrados = responseProdutos.data
                    .map(i => {
                        const nomeProduto = i.nome.trimEnd();
                        const nomeFormatado = nomeProduto.charAt(0).toUpperCase() + nomeProduto.slice(1).toLowerCase();
                        return {
                            label: nomeFormatado,
                            value: i.id,
                            nomeSemEspaco: nomeProduto.toLowerCase().trimEnd()
                        };
                    })
                    .filter(i => {
                        if (i.nomeSemEspaco !== "abacate - não usar") {
                            if (!nomesUnicos.has(i.nomeSemEspaco)) {
                                nomesUnicos.add(i.nomeSemEspaco);
                                return true;
                            }
                        }
                        return false;
                    });

                setProdutosAntigoId(produtosFiltrados);
            } catch (error) {
                toast.current.show({ severity: 'error', summary: 'Erro ao obter produtos', detail: error.toString() });
            }
        }

        carregarProdutosAntigoId();
    }, []);

    useEffect(() => {
        //carrega o produto do boletimItem
        async function carregarProdutosId() {
            try {
                const responseProdutos = await api.get('produto/produtosAll');
                setProdutosId(responseProdutos.data.map(i => ({
                    label: `${i.nome}`,
                    value: i.id
                })));
            } catch (error) {
                toast.current.show({ severity: 'error', summary: 'Erro ao obter produtos', detail: error.toString() });
            }
        }

        carregarProdutosId();
    }, []);

    useEffect(() => {
        //dados do boletimItens
        const fetchData = async () => {
            try {
                const response = await api.get(`boletimitens/${id}`);

                await formik.setValues(
                    (prevValues) => ({
                        ...prevValues,
                        id: response.data.id || "",
                        boletimItemId: response.data.id || "",
                        produtoId: response.data.produtoId || "",
                    }),
                    true
                );
            } catch (error) {
                console.error("Erro ao buscar os dados do item:", error);
            }
        };

        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    useEffect(() => {
        //lógica de edição
        const fetchData = async () => {
            if (isEditing) {
                try {
                    const responseCaderno = await api.get(`/caderno/boletimItem/${id}`);
                    const responseBoletimItem = await api.get(`boletimitens/${id}`);

                    console.log('Dados do boletim item (produtoId):', responseBoletimItem.data.produtoId);

                    setVisualCodigo(responseBoletimItem.data.id || "");
                    setVisualCulturaAtual(responseBoletimItem.data.produtoId || "");

                    const valoresPadrao = {
                        ...formik.values,
                        id: responseCaderno.data.id || "",
                        boletimItemId: responseBoletimItem.data.id || "",
                        produtoId: responseBoletimItem.data.produtoId || "", // Garantir que isso está sendo setado
                        produtoAntigoId: responseCaderno.data.produtoAntigoId || "",
                        dataPlantio: responseCaderno.data.dataPlantio || "",
                        dataColheita: responseCaderno.data.dataColheita || "",
                        identificacaoArea: responseCaderno.data.areaCultivo || "",
                        preparoSolo: responseCaderno.data.preparoSolo || {
                            naoNecessarias: false,
                            subsolagem: false,
                            aracao: false,
                            enxadaRotativa: false,
                            gradagemComGrade: false,
                            leve: false,
                            pesada: false,
                            niveladora: false,
                            outras: false,
                            descricaoOutras: "",
                        },
                        praticasConservacionistas: responseCaderno.data.praticasConservacionistas || {
                            naoNecessarias: false,
                            plantioEmNivel: false,
                            terracos: false,
                            rotacaoDeCulturas: false,
                            adubacaoVerde: false,
                            outras: false,
                            descricaoOutras: "",
                        },
                        sementesEMudas: responseCaderno.data.sementesEMudas || {
                            naoNecessarias: false,
                            proprias: false,
                            terceiros: false,
                            viveiroComTermico: false,
                            viveiroSemTermico: false,
                        },
                        irrigacao: responseCaderno.data.irrigacao || {
                            naoNecessarias: false,
                            sistema: "",
                            origem: "",
                        },
                        adubacaoCorrecao: responseCaderno.data.adubacaoCorrecao || [],
                        aplicacaoProdutosQuimicos: responseCaderno.data.aplicacaoProdutosQuimicos || [],
                    };

                    formik.setValues(valoresPadrao);
                    setAdubacoesCorrecao(responseCaderno.data.adubacaoCorrecao || []);
                    setAplicacoesProdutosQuimicos(responseCaderno.data.aplicacaoProdutosQuimicos || []);
                } catch (error) {
                    console.error("Erro ao buscar os dados do caderno de campo:", error);
                }
            }
        };

        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, isEditing]);

    useEffect(() => {
        if (formik.values.preparoSolo && formik.touched.preparoSolo) {
            formik.validateForm();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formik.values.preparoSolo, formik.touched.preparoSolo]);

    useEffect(() => {
        if (formik.values.praticasConservacionistas && formik.touched.praticasConservacionistas) {
            formik.validateForm();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formik.values.praticasConservacionistas, formik.touched.praticasConservacionistas]);

    useEffect(() => {
        if (formik.values.sementesEMudas && formik.touched.sementesEMudas) {
            formik.validateForm();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formik.values.sementesEMudas, formik.touched.sementesEMudas]);

    useEffect(() => {
        if (formik.values.irrigacao && formik.touched.irrigacao) {
            formik.validateForm();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formik.values.irrigacao, formik.touched.irrigacao]);

    useEffect(() => {
        // validacao da tab adubacaoCorrecao
        if (visitedTabs.adubacaoCorrecao) {
            const isValid = adubacoesCorrecao.length > 0;
            setIsAdubacaoCorrecaoValid(isValid);

            if (!isValid) {
                formik.setFieldError("adubacaoCorrecao", "Pelo menos um item de Adubação e Correção deve ser adicionado.");
            } else {
                formik.setFieldError("adubacaoCorrecao", "");
            }

            setAdubacaoValidated(true);
            formik.setFieldTouched("adubacaoCorrecao", true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [adubacoesCorrecao, visitedTabs.adubacaoCorrecao]);

    useEffect(() => {
        // validação da tab apq
        if (visitedTabs.aplicacaoProdutosQuimicos) {
            const isValid = aplicacoesProdutosQuimicos.length > 0;
            setIsAplicacaoProdutosQuimicosValid(isValid);

            if (!isValid) {
                formik.setFieldError("aplicacaoProdutosQuimicos", "Pelo menos um item de Aplicação de Produtos Químicos deve ser adicionado.");
            } else {
                formik.setFieldError("aplicacaoProdutosQuimicos", "");
            }

            setAplicacaoValidated(true);
            formik.setFieldTouched("aplicacaoProdutosQuimicos", true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [aplicacoesProdutosQuimicos, visitedTabs.aplicacaoProdutosQuimicos]);

    useEffect(() => {
        const tabNames = [
            'preparoSolo',
            'sementesEMudas',
            'irrigacao',
            'adubacaoCorrecao',
            'aplicacaoProdutosQuimicos'
        ];

        setVisitedTabs(prev => ({
            ...prev,
            [tabNames[activeIndex]]: true,
        }));

    }, [activeIndex]);

    return (
        <>
            <div className="card p-grid p-col-12 p-mx-0 p-mt-0">
                <Toast ref={toast} position="bottom-right" />
                <div className="p-col-12">
                    <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                        <h2 className="p-mt-0" style={{ margin: 0 }}>Caderno de Campo</h2>
                        {isEditing && (
                            <Button
                                icon="pi pi-print"
                                className="p-button-rounded edit-btn"
                                onClick={handlePrintClick}
                            />
                        )}
                    </div>

                    <hr style={{ border: '3px hidden' }} />


                    <form onSubmit={formik.handleSubmit}>
                        <div className="p-formgrid p-grid p-fluid p-mx-0">
                            <div className="p-field p-col-12 p-sm-4">
                                <label
                                    htmlFor="id"
                                    className={classNames({ 'p-error': isFormFieldValid('id') })}
                                >
                                    Código
                                </label>
                                {
                                    !isLoading ?
                                        <InputText
                                            id="id"
                                            name="id"
                                            className={classNames({ 'p-invalid': isFormFieldValid('id') })}
                                            value={isEditing ? visualCodigo : formik.values.id}
                                            onChange={formik.handleChange}
                                            disabled
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.id && formik.touched.id &&
                                    <ErrorValidationMessage message={formik.errors.id} />
                                }
                            </div>

                            <div className="p-field p-col-12 p-sm-4">
                                <label
                                    htmlFor="produtoId"
                                    className={classNames({ 'p-error': isFormFieldValid('produtoId') })}
                                >
                                    Cultura Atual
                                </label>
                                {
                                    !isLoading ?
                                        <Dropdown
                                            id="produtoId"
                                            name="produtoId"
                                            options={produtosId}
                                            optionValue='value'
                                            optionLabel='label'
                                            emptyMessage="Nenhum produto encontrado"
                                            emptyFilterMessage={"Nenhum produto encontrado"}
                                            filter={true}
                                            value={isEditing ? visualCulturaAtual : formik.values.produtoId}
                                            onChange={(e) => formik.setFieldValue("produtoId", e.value)}
                                            className={classNames({ 'p-invalid': isFormFieldValid('produtoId') })}
                                            placeholder="Selecione um produto"
                                            showClear={true}
                                            disabled
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.produtoId && formik.touched.produtoId &&
                                    <ErrorValidationMessage message={formik.errors.produtoId} />
                                }
                            </div>

                            <div className="p-field p-col-12 p-sm-4">
                                <label
                                    htmlFor="produtoAntigoId"
                                    className={classNames({ 'p-error': isFormFieldValid('produtoAntigoId') })}
                                >
                                    Cultura Anterior
                                </label>
                                {
                                    !isLoading ?
                                        <Dropdown
                                            id="produtoAntigoId"
                                            name="produtoAntigoId"
                                            options={produtosAntigoId}
                                            optionValue='value'
                                            optionLabel='label'
                                            emptyMessage="Nenhum produto encontrado"
                                            emptyFilterMessage={"Nenhum produto encontrado"}
                                            filter={true}
                                            value={formik.values.produtoAntigoId}
                                            onChange={(e) => formik.setFieldValue("produtoAntigoId", e.value)}
                                            className={classNames({ 'p-invalid': isFormFieldValid('produtoAntigoId') })}
                                            placeholder="Selecione um produto"
                                            showClear={true}
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.produtoAntigoId && formik.touched.produtoAntigoId &&
                                    <ErrorValidationMessage message={formik.errors.produtoAntigoId} />
                                }
                            </div>

                            <div className="p-field p-col-12 p-sm-4 p-md-4">
                                <label
                                    htmlFor="dataPlantio"
                                    className={classNames({ 'p-error': isFormFieldValid('dataPlantio') })}
                                >
                                    Data de Plantio
                                </label>
                                <BrCalendar
                                    id="dataPlantio"
                                    name="dataPlantio"
                                    value={formik.values.dataPlantio}
                                    onChange={formik.handleChange}
                                    placeholder={isEditing ? new Date(formik.values.dataPlantio).toLocaleDateString('pt-BR') : ""}
                                    className={classNames({ 'p-invalid': isFormFieldValid('dataPlantio') })}
                                    yearRange={`${new Date().getFullYear() - 4}:${new Date().getFullYear() + 1}`}
                                    disabledDays="none"
                                />
                                {formik.errors.dataPlantio && formik.touched.dataPlantio &&
                                    <ErrorValidationMessage message={formik.errors.dataPlantio} />
                                }
                            </div>

                            <div className="p-field p-col-12 p-sm-4 p-md-4">
                                <label
                                    htmlFor="dataColheita"
                                    className={classNames({ 'p-error': isFormFieldValid('dataColheita') })}
                                >
                                    Data Provável de Colheita
                                </label>
                                <BrCalendar
                                    id="dataColheita"
                                    name="dataColheita"
                                    value={formik.values.dataColheita}
                                    onChange={formik.handleChange}
                                    placeholder={isEditing ? new Date(formik.values.dataColheita).toLocaleDateString('pt-BR') : ""}
                                    className={classNames({ 'p-invalid': isFormFieldValid('dataColheita') })}
                                    yearRange={`${new Date().getFullYear() - 4}:${new Date().getFullYear() + 1}`}
                                    disabledDays="none"
                                />
                                {formik.errors.dataColheita && formik.touched.dataColheita &&
                                    <ErrorValidationMessage message={formik.errors.dataColheita} />
                                }
                            </div>

                            <div className="p-field p-col-12 p-sm-4">
                                <label
                                    htmlFor="identificacaoArea"
                                    className={classNames({ 'p-error': isFormFieldValid('identificacaoArea') })}
                                >
                                    Identificação da Área de Cultivo
                                </label>
                                {
                                    !isLoading ?
                                        <InputText
                                            id="identificacaoArea"
                                            name="identificacaoArea"
                                            className={classNames({ 'p-invalid': isFormFieldValid('identificacaoArea') })}
                                            value={formik.values.identificacaoArea}
                                            onChange={formik.handleChange} disabled={isLoading}
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.identificacaoArea && formik.touched.identificacaoArea &&
                                    <ErrorValidationMessage message={formik.errors.identificacaoArea} />
                                }
                            </div>
                        </div>

                        <br />

                        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} style={{ width: '100%' }}>
                            <TabPanel
                                headerTemplate={
                                    <div
                                        style={{
                                            ...(
                                                (hasErrorPreparoSolo && visitedTabs.preparoSolo) ||
                                                    (formik.errors.praticasConservacionistas && visitedTabs.preparoSolo)
                                                    ? tabHeaderStyle.error
                                                    : tabHeaderStyle.normal
                                            ),
                                            ...(activeIndex === 0 && tabHeaderStyle.active),
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = tabHeaderStyle.hover.backgroundColor;
                                            e.currentTarget.style.borderBottom = tabHeaderStyle.hover.borderBottom;
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = 'transparent';
                                            e.currentTarget.style.borderBottom = activeIndex === 0
                                                ? tabHeaderStyle.active.borderBottom
                                                : 'none';
                                        }}
                                        onClick={() => setActiveIndex(0)}
                                    >
                                        Preparo do Solo
                                    </div>
                                }
                            >
                                <FormPreparoSolo
                                    values={formik.values.preparoSolo}
                                    setFieldValue={formik.setFieldValue}
                                    setFieldTouched={formik.setFieldTouched}
                                    errors={formik.errors.preparoSolo}
                                    touched={formik.touched.preparoSolo}
                                />
                                <FormPraticasConservacionistas
                                    values={formik.values.praticasConservacionistas}
                                    setFieldValue={formik.setFieldValue}
                                    setFieldTouched={formik.setFieldTouched}
                                    errors={formik.errors.praticasConservacionistas}
                                    touched={formik.touched.praticasConservacionistas}
                                />
                            </TabPanel>

                            <TabPanel
                                headerTemplate={
                                    <div
                                        style={{
                                            ...(
                                                (hasErrorSementesEMudas && visitedTabs.sementesEMudas) ||
                                                    (formik.errors.sementesEMudas && visitedTabs.sementesEMudas) || hasErrorSementesEMudas
                                                    ? tabHeaderStyle.error
                                                    : tabHeaderStyle.normal
                                            ),
                                            ...(activeIndex === 1 && tabHeaderStyle.active),
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = tabHeaderStyle.hover.backgroundColor;
                                            e.currentTarget.style.borderBottom = tabHeaderStyle.hover.borderBottom;
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = 'transparent';
                                            e.currentTarget.style.borderBottom = activeIndex === 1
                                                ? tabHeaderStyle.active.borderBottom
                                                : 'none';
                                        }}
                                        onClick={() => setActiveIndex(1)}
                                    >
                                        Sementes e Mudas
                                    </div>
                                }
                            >
                                <FormSementesEMudas
                                    visible={showFormCaderno}
                                    setVisible={setShowFormCaderno}
                                    values={formik.values.sementesEMudas}
                                    setFieldValue={formik.setFieldValue}
                                    setFieldTouched={formik.setFieldTouched}
                                    errors={formik.errors.sementesEMudas}
                                    touched={formik.touched.sementesEMudas}
                                />
                            </TabPanel>

                            <TabPanel
                                headerTemplate={
                                    <div
                                        style={{
                                            ...(
                                                (hasErrorIrrigacao && visitedTabs.irrigacao) ||
                                                    (formik.errors.irrigacao && visitedTabs.irrigacao) || hasErrorIrrigacao
                                                    ? tabHeaderStyle.error
                                                    : tabHeaderStyle.normal
                                            ),
                                            ...(activeIndex === 2 && tabHeaderStyle.active),
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = tabHeaderStyle.hover.backgroundColor;
                                            e.currentTarget.style.borderBottom = tabHeaderStyle.hover.borderBottom;
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = 'transparent';
                                            e.currentTarget.style.borderBottom = activeIndex === 2
                                                ? tabHeaderStyle.active.borderBottom
                                                : 'none';
                                        }}
                                        onClick={() => setActiveIndex(2)}
                                    >
                                        Irrigação
                                    </div>
                                }
                            >
                                <FormIrrigacao
                                    visible={showFormCaderno}
                                    setVisible={setShowFormCaderno}
                                    values={formik.values.irrigacao}
                                    setFieldValue={formik.setFieldValue}
                                    setFieldTouched={formik.setFieldTouched}
                                    errors={formik.errors.irrigacao}
                                    touched={formik.touched.irrigacao}
                                />
                            </TabPanel>

                            <TabPanel
                                headerTemplate={
                                    <div
                                        style={{
                                            ...((formik.errors.adubacaoCorrecao && formik.touched.adubacaoCorrecao) || (adubacaoValidated && !isAdubacaoCorrecaoValid)
                                                ? tabHeaderStyle.error
                                                : tabHeaderStyle.normal
                                            ),
                                            ...(activeIndex === 3 && tabHeaderStyle.active),
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = tabHeaderStyle.hover.backgroundColor;
                                            e.currentTarget.style.borderBottom = tabHeaderStyle.hover.borderBottom;
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = 'transparent';
                                            e.currentTarget.style.borderBottom = activeIndex === 3
                                                ? tabHeaderStyle.active.borderBottom
                                                : 'none';
                                        }}
                                        onClick={() => setActiveIndex(3)}
                                    >
                                        Adubação e Correção
                                    </div>
                                }
                            >
                                {formik.errors.adubacaoCorrecao && formik.touched.adubacaoCorrecao && (
                                    <div className="p-error p-mt-2">
                                        {formik.errors.adubacaoCorrecao}
                                    </div>
                                )}
                                <FormAdubacaoCorrecao
                                    visible={showFormCaderno}
                                    setVisible={setShowFormCaderno}
                                    adubacaoCorrecao={adubacoesCorrecao}
                                    setAdubacaoCorrecao={setAdubacoesCorrecao}
                                    isEditing={isEditing}
                                    isLoading={isLoading}
                                />
                                <div className="p-d-flex p-jc-end p-mr-1" id="AdubacaoCorrecao">
                                    <TabelaAdubacaoCorrecao
                                        adubacaoCorrecao={adubacoesCorrecao}
                                        setAdubacaoCorrecao={setAdubacoesCorrecao}
                                        isEditing={isEditing}
                                    />
                                </div>
                            </TabPanel>

                            <TabPanel
                                headerTemplate={
                                    <div
                                        style={{
                                            ...((formik.errors.aplicacaoProdutosQuimicos && formik.touched.aplicacaoProdutosQuimicos) || (aplicacaoValidated && !isAplicacaoProdutosQuimicosValid)
                                                ? tabHeaderStyle.error
                                                : tabHeaderStyle.normal
                                            ),
                                            ...(activeIndex === 4 && tabHeaderStyle.active),
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = tabHeaderStyle.hover.backgroundColor;
                                            e.currentTarget.style.borderBottom = tabHeaderStyle.hover.borderBottom;
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = 'transparent';
                                            e.currentTarget.style.borderBottom = activeIndex === 4
                                                ? tabHeaderStyle.active.borderBottom
                                                : 'none';
                                        }}
                                        onClick={() => setActiveIndex(4)}
                                    >
                                        Aplicação de Produtos Químicos
                                    </div>
                                }
                            >
                                {formik.errors.aplicacaoProdutosQuimicos && formik.touched.aplicacaoProdutosQuimicos && (
                                    <div className="p-error p-mt-2">
                                        {formik.errors.aplicacaoProdutosQuimicos}
                                    </div>
                                )}
                                <FormAplicacaoProdutosQuimicos
                                    visible={showFormCaderno}
                                    setVisible={setShowFormCaderno}
                                    aplicacaoProdutosQuimicos={aplicacoesProdutosQuimicos}
                                    setAplicacaoProdutosQuimicos={setAplicacoesProdutosQuimicos}
                                    isEditing={isEditing}
                                    isLoading={isLoading}
                                />
                                <div className="p-d-flex p-jc-end p-mr-1" id="AplicacaoProdutosQuimicos">
                                    <TabelaAplicacaoProdutosQuimicos
                                        aplicacaoProdutosQuimicos={aplicacoesProdutosQuimicos}
                                        setAplicacaoProdutosQuimicos={setAplicacoesProdutosQuimicos}
                                        isEditing={isEditing}
                                    />
                                </div>
                            </TabPanel>
                        </TabView>

                        <DialogPrintCaderno
                            visible={showPrintCaderno}
                            setVisible={setShowPrintCaderno}
                            setCadernos={setCadernoPrint}
                            cadernos={cadernoPrint}
                            produtoAntigoPrint={produtoAntigoPrint}
                            produtoPrint={produtoPrint}
                        />

                        <div className="p-d-flex p-jc-end p-mr-1" style={{ marginTop: '10px' }}>
                            {
                                !isLoading ?
                                    <Button
                                        label={isEditing ? 'Atualizar' : 'Salvar'}
                                        type="submit"
                                        iconPos="right"
                                        loading={isSubmiting}
                                        disabled={isSubmiting}
                                    />
                                    :
                                    <Skeleton width="82.16px" height="35px" />
                            }
                        </div>
                        <></>
                    </form>
                </div>
            </div>
        </>
    );
}
